module.exports = __webpack_public_path__ + "static/media/course7.b634b354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course7.png
// module id = 2846
// module chunks = 0